/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Sku } from './Sku';
// @ts-ignore
import {
// @ts-ignore
    SkuFromJSON,
// @ts-ignore
    SkuFromJSONTyped,
// @ts-ignore
    SkuToJSON,
} from './Sku';

/**
 * 
 * @export
 * @interface SkuListResponse
 */
export interface SkuListResponse {
    /**
     * 
     * @type {number}
     * @memberof SkuListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SkuListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Sku>}
     * @memberof SkuListResponse
     */
    items: Array<Sku>;
}

/**
 * Check if a given object implements the SkuListResponse interface.
 */
// @ts-ignore
export function instanceOfSkuListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function SkuListResponseFromJSON(json: any): SkuListResponse {
    return SkuListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function SkuListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(SkuFromJSON)),
    };
}

// @ts-ignore
export function SkuListResponseToJSON(value?: SkuListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(SkuToJSON)),
    };
}

